import React from 'react';
import { observer } from 'mobx-react';

import { analytics } from 'core/analytics';
import { useRouterStore } from 'apps/hooks';
import { useViewerControl } from 'libs/rendering/gltf/hooks';

import { Panel } from '../panel';
import DfmAnalysis from './dfmAnalysis';

const DfmPanel = observer(() => {
  const routerStore = useRouterStore();
  const viewerControl = useViewerControl();

  if (!viewerControl?.viewer) return null;
  const settings = viewerControl?.viewer?.settings;
  const camera = settings?.CurrentCamera();
  const instance = camera?.GetInstance();
  const body = instance?.GetBody();
  if (!body) return null;

  function collapseDfmAnalysis() {
    const newParams = Object.assign({}, routerStore.route.params);
    if (newParams.panel === 'dfm') {
      delete newParams.panel;
      analytics.sendEvent('dfm-tool-hide');
    }

    routerStore.navigate(routerStore.route.name, newParams, {
      replace: true,
    });
  }

  return (
    <Panel
      position='right'
      title='DFM Analysis'
      iconName='mesh'
      removeHeader
      collapseAction={collapseDfmAnalysis}
      isOpen={viewerControl.meshAnalysis.visible}
    >
      <DfmAnalysis body={body} />
    </Panel>
  );
});

export default DfmPanel;
